import logo from "../../assets/logo.svg";
import "./style.css";

const Footer = () => {
	return (
		<footer>
			<div className="container">
				<div className="row">
					<div className="col-md-4">
						<img src={logo} alt="logo" />
						<p className="description">
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverra
							nunc ante velit vitae. Est tellus vitae, nullam lobortis enim.
						</p>
						<div className="social">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_64_247)">
									<path
										d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"
										fill="#D80026"
									/>
								</g>
								<defs>
									<clipPath id="clip0_64_247">
										<rect width="24" height="24" fill="white" />
									</clipPath>
								</defs>
							</svg>

							<div className="separte"></div>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_64_217)">
									<path
										d="M12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2ZM12 7C10.6739 7 9.40215 7.52678 8.46447 8.46447C7.52678 9.40215 7 10.6739 7 12C7 13.3261 7.52678 14.5979 8.46447 15.5355C9.40215 16.4732 10.6739 17 12 17C13.3261 17 14.5979 16.4732 15.5355 15.5355C16.4732 14.5979 17 13.3261 17 12C17 10.6739 16.4732 9.40215 15.5355 8.46447C14.5979 7.52678 13.3261 7 12 7ZM18.5 6.75C18.5 6.41848 18.3683 6.10054 18.1339 5.86612C17.8995 5.6317 17.5815 5.5 17.25 5.5C16.9185 5.5 16.6005 5.6317 16.3661 5.86612C16.1317 6.10054 16 6.41848 16 6.75C16 7.08152 16.1317 7.39946 16.3661 7.63388C16.6005 7.8683 16.9185 8 17.25 8C17.5815 8 17.8995 7.8683 18.1339 7.63388C18.3683 7.39946 18.5 7.08152 18.5 6.75ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9Z"
										fill="#D80026"
									/>
								</g>
								<defs>
									<clipPath id="clip0_64_217">
										<rect width="24" height="24" fill="white" />
									</clipPath>
								</defs>
							</svg>

							<div className="separte"></div>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_48_515)">
									<path
										d="M22.162 5.65593C21.3985 5.99362 20.589 6.2154 19.76 6.31393C20.6337 5.79136 21.2877 4.96894 21.6 3.99993C20.78 4.48793 19.881 4.82993 18.944 5.01493C18.3146 4.34151 17.4803 3.89489 16.5709 3.74451C15.6615 3.59413 14.7279 3.74842 13.9153 4.18338C13.1026 4.61834 12.4564 5.30961 12.0771 6.14972C11.6978 6.98983 11.6067 7.93171 11.818 8.82893C10.1551 8.74558 8.52832 8.31345 7.04328 7.56059C5.55823 6.80773 4.24812 5.75097 3.19799 4.45893C2.82628 5.09738 2.63095 5.82315 2.63199 6.56193C2.63199 8.01193 3.36999 9.29293 4.49199 10.0429C3.828 10.022 3.17862 9.84271 2.59799 9.51993V9.57193C2.59819 10.5376 2.93236 11.4735 3.54384 12.221C4.15532 12.9684 5.00647 13.4814 5.95299 13.6729C5.33661 13.84 4.6903 13.8646 4.06299 13.7449C4.32986 14.5762 4.85 15.3031 5.55058 15.824C6.25117 16.3449 7.09712 16.6337 7.96999 16.6499C7.10247 17.3313 6.10917 17.8349 5.04687 18.1321C3.98458 18.4293 2.87412 18.5142 1.77899 18.3819C3.69069 19.6114 5.91609 20.264 8.18899 20.2619C15.882 20.2619 20.089 13.8889 20.089 8.36193C20.089 8.18193 20.084 7.99993 20.076 7.82193C20.8949 7.23009 21.6016 6.49695 22.163 5.65693L22.162 5.65593Z"
										fill="#D80026"
									/>
								</g>
								<defs>
									<clipPath id="clip0_48_515">
										<rect width="24" height="24" fill="white" />
									</clipPath>
								</defs>
							</svg>

							<div className="separte"></div>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_48_517)">
									<path
										d="M21.543 6.498C22 8.28 22 12 22 12C22 12 22 15.72 21.543 17.502C21.289 18.487 20.546 19.262 19.605 19.524C17.896 20 12 20 12 20C12 20 6.107 20 4.395 19.524C3.45 19.258 2.708 18.484 2.457 17.502C2 15.72 2 12 2 12C2 12 2 8.28 2.457 6.498C2.711 5.513 3.454 4.738 4.395 4.476C6.107 4 12 4 12 4C12 4 17.896 4 19.605 4.476C20.55 4.742 21.292 5.516 21.543 6.498ZM10 15.5L16 12L10 8.5V15.5Z"
										fill="#D80026"
									/>
								</g>
								<defs>
									<clipPath id="clip0_48_517">
										<rect width="24" height="24" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
					<div className="col-md-4 links">
						<p className="title">quick link</p>
						<div>
							<a href="#Home">Home</a>
							<a href="#About">About</a>
							<a href="#Features">Features</a>
							<a href="#Screenshot">Screenshot</a>
							<a href="#Privacy">Privacy</a>
						</div>
					</div>
					<div className="col-md-4">
						<p className="title">news letter</p>
						<p className="description">
							Subscribe our newsletter to get our latest update & news
						</p>
						<div className="subscribe-input">
							<input type="text" placeholder="Your email address" />
							<svg
								width="40"
								height="41"
								viewBox="0 0 40 41"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<rect y="0.5" width="40" height="40" rx="5" fill="#D80026" />
								<g clip-path="url(#clip0_48_530)">
									<path
										d="M11 21.5001H17V19.5001H11V10.3461C11 10.2592 11.0227 10.1738 11.0657 10.0984C11.1088 10.0229 11.1708 9.95997 11.2456 9.91576C11.3204 9.87155 11.4054 9.84759 11.4923 9.84625C11.5791 9.84491 11.6649 9.86623 11.741 9.90811L30.203 20.0621C30.2814 20.1053 30.3468 20.1687 30.3923 20.2457C30.4378 20.3228 30.4618 20.4106 30.4618 20.5001C30.4618 20.5896 30.4378 20.6774 30.3923 20.7545C30.3468 20.8315 30.2814 20.8949 30.203 20.9381L11.741 31.0921C11.6649 31.134 11.5791 31.1553 11.4923 31.154C11.4054 31.1526 11.3204 31.1287 11.2456 31.0844C11.1708 31.0402 11.1088 30.9773 11.0657 30.9018C11.0227 30.8264 11 30.741 11 30.6541V21.5001Z"
										fill="white"
									/>
								</g>
								<defs>
									<clipPath id="clip0_48_530">
										<rect
											width="24"
											height="24"
											fill="white"
											transform="translate(8 8.5)"
										/>
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
				</div>
				<hr />
				<p className="power">
					© <a href="#Home">Powered by Teknulugy</a> | All rights reserved
				</p>
			</div>
		</footer>
	);
};
export default Footer;
